import { combineReducers } from 'redux';
import { CustomerServiceState } from './types';
import { reportingReducer } from './reporting/reducer';

const customerServiceReducer = combineReducers<CustomerServiceState>({
    reporting: reportingReducer
});

export { customerServiceReducer };